export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/createSchool`,
                method: 'POST',
                body: payload
            };
        },
        invalidatesTags: ['allExamSchools'] 

    })
